module.exports = __webpack_public_path__ + "img/2x.107b1ea.jpg";